'use client';
import Link from '@/components/LocaleLink';
import {  useEffect, useMemo } from 'react';
import { useTranslation } from '@/contexts/TranslationContext';

import {
  // babyIntermediaryUrls,
  // toddlerIntermediaryUrls,
  // preSchoolerIntermediaryUrls,
  // childIntermediaryUrls,
  teenaagerIntermediaryUrls,
  youngAdultIntermediaryUrls,
  youngProfessionalIntermediaryUrls,
  professionalAdultIntermediaryUrls,
  middleAgedAdultIntermediaryUrls,
  lateMiddleAgedAdultIntermediaryUrls,
  retireesIntermediaryUrls,
  seniorsIntermediaryUrls,
} from '@/utils/intermediary_url_service';
import { getChartTypeLabel, formulateGenderAndChartType, parseUrlForGenderWithString, enablePrimaryLink } from '@/utils/maps';
import { seo } from '@/utils/seo';

// UI components
import Collapsible from './collapsible';

const ChartsGender = ({
  // openBabyDefault = false,
  // showBabyDropdown = true,
  // showToddlerDropdown = true,
  // showPreschoolerDropdown = true,
  // showChildDropdown = true,
  showTeenagerDropdown = true,
  // showyoungAdultDropdown = true,
  contentBlock = null, // Passed from server component
  pathname = '',
}) => {
  // const pathname = usePathname();
  const { t, locale } = useTranslation();
  const hashArray = useMemo(() => pathname.split('/'), [pathname]);
  // const [contentBlock, setContentBlock] = useState();

  // Memoize the intermediary URL maps based on hashArray changes
  // const babymap = useMemo(() => babyIntermediaryUrls(hashArray[1], hashArray[2]), [hashArray]);
  // const toddlerMap = useMemo(() => toddlerIntermediaryUrls(hashArray[1], hashArray[2]), [hashArray]);
  // const preSchoolerMap = useMemo(() => preSchoolerIntermediaryUrls(hashArray[1], hashArray[2]), [hashArray]);
  // const childMap = useMemo(() => childIntermediaryUrls(hashArray[1], hashArray[2]), [hashArray]);
  const teenMap = useMemo(() => teenaagerIntermediaryUrls(hashArray[1], hashArray[2]), [hashArray]);
  const youngAdult = useMemo(() => youngAdultIntermediaryUrls(hashArray[1], hashArray[2]));
  const youngProfessional = useMemo(() => youngProfessionalIntermediaryUrls(hashArray[1], hashArray[2]));
  const professionalAdult = useMemo(() => professionalAdultIntermediaryUrls(hashArray[1], hashArray[2]));
  const middleAgedAdult = useMemo(() => middleAgedAdultIntermediaryUrls(hashArray[1], hashArray[2]));
  const lateMiddleAgedAdult = useMemo(() => lateMiddleAgedAdultIntermediaryUrls(hashArray[1], hashArray[2]));
  const retirees = useMemo(() => retireesIntermediaryUrls(hashArray[1], hashArray[2]));
  const seniors = useMemo(() => seniorsIntermediaryUrls(hashArray[1], hashArray[2]));
  // const fetchData = async () => {
  //   const content = await fetchIntermediaryContentByUrl(window.location.pathname);
  //   setContentBlock(content?.generator); // Update state with fetched content
  // };
  // SEO and localStorage cleanup on pathname change
  useEffect(() => {
    if(pathname){
    seo(pathname);
    localStorage.removeItem('lm_heigh_data');
    localStorage.removeItem('lm_weight_data');
    localStorage.removeItem('lm_head_data');
    localStorage.removeItem('lm_bmi_data');
    // fetchData();
    }
  }, [pathname]);
  // const [hashArray, setHashArray] = useState(pathname.split('/'));
  // const [babymap, setBabyMap] = useState(babyIntermediaryUrls(hashArray[1], hashArray[2]));
  // const [toddlerMap, setToddlerMap] = useState(toddlerIntermediaryUrls(hashArray[1], hashArray[2]));
  // const [preSchoolerMap, setSchoolerMap] = useState(preSchoolerIntermediaryUrls(hashArray[1], hashArray[2]));
  // const [childMap, setChildMap] = useState(childIntermediaryUrls(hashArray[1], hashArray[2]));
  // const [teenMap, setTeenMap] = useState(teenaagerIntermediaryUrls(hashArray[1], hashArray[2]));

  // useEffect(() => {
  //   seo(window.location.pathname);
  //   localStorage.removeItem('lm_heigh_data');
  //   localStorage.removeItem('lm_weight_data');
  //   localStorage.removeItem('lm_head_data');
  //   localStorage.removeItem('lm_bmi_data');

  //   if (hashArray.join('/') !== pathname) {
  //     let tempArray = pathname.split('/');
  //     setHashArray(tempArray);
  //     setBabyMap(babyIntermediaryUrls(tempArray[1], tempArray[2]));
  //     setToddlerMap(toddlerIntermediaryUrls(tempArray[1], tempArray[2]));
  //     setSchoolerMap(preSchoolerIntermediaryUrls(tempArray[1], tempArray[2]));
  //     setChildMap(childIntermediaryUrls(tempArray[1], tempArray[2]));
  //     setTeenMap(teenaagerIntermediaryUrls(tempArray[1], tempArray[2]));
  //   }
  // }, [pathname]);
  return (
    <div id="content" className="app-content texture-bg" role="main">
      <div className="bg-green-div d-md-none" />
      <div className="app-content-body-white">
        <div className="chart-top content-container  wrapper-md pb-3 pb-sm-0">
          {contentBlock && contentBlock?.top_content?.length > 1 ? (
            <h1 className="mb-2 mb-md-4" dangerouslySetInnerHTML={{ __html: contentBlock.title }}></h1>
          ) : (
            <h1 className="mb-2 mb-md-4">
              {hashArray[2] === 'household'
                ? t('chartsGender.h1.household', { chartType: getChartTypeLabel(hashArray[1], locale) })
                : t('chartsGender.h1.allAges', {
                    chartType: getChartTypeLabel(hashArray[1], locale),
                    gender: t(hashArray[2] === 'men' ? 'form.men' : 'form.women'),
                  })}
            </h1>
          )}
          <nav aria-label={t('aria.breadcrumb')}>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link prefetch={false} href="/">
                  {t('nav.home')}
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link prefetch={false} href={`/${hashArray[1]}`}>
                  {getChartTypeLabel(hashArray[1], locale)}
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {parseUrlForGenderWithString(hashArray, locale)}
              </li>
            </ol>
          </nav>
        </div>
        <div className="wrapper-md pt-3">
          <div className="row">
            {contentBlock && contentBlock.top_content && (
              <div className="col-12" dangerouslySetInnerHTML={{ __html: contentBlock.top_content }}></div>
            )}
          </div>
        </div>
        <div className="wrapper-md pt-3">
          <div className="row" style={{ flexDirection: 'column' }}>
            {/* {showBabyDropdown ? (
              <div className="col col-md-12">
                <div className="d-flex align-items-center mb-3 mb-md-4 gap-2">
                  <div className="icon-bg" weight="30" height="30">
                    <img src="/assets/images/icons/baby.svg" alt="icon" />
                  </div>
                  <h3 className="font-thin h3 heading-text">Baby</h3>
                </div>
                <Collapsible title={'0-23 months old'} id={1} className="age-accordion" grid open={openBabyDefault}>
                  {Object.keys(babymap).map((key) => (
                    <Link
                      key={key}
                      prefetch={false}
                      href={babymap[key]}
                      className={enablePrimaryLink(key, babymap[key]) ? 'primary-age' : 'secondary-age'}
                    >
                      <div className="box text-center">{t('breadcrumb.ageYears', { age: parseInt(key, 10) })}</div>
                    </Link>
                  ))}
                </Collapsible>
              </div>
            ) : null} */}

            {/* {showToddlerDropdown ? (
              <div className="col col-md-12">
                <div className="d-flex align-items-center mb-3 mb-md-4 gap-2">
                  <div className="icon-bg" weight="30" height="30">
                    <img src="/assets/images/icons/toddler.svg" alt="icon" />
                  </div>
                  <h3 className="font-thin h3 heading-text">Toddler</h3>
                </div>
                <Collapsible title={'24-35 months old'} id={2} className="age-accordion" grid>
                  {Object.keys(toddlerMap).map((key) => (
                    <Link
                      key={key}
                      prefetch={false}
                      href={toddlerMap[key]}
                      className={enablePrimaryLink(key, toddlerMap[key]) ? 'primary-age' : 'secondary-age'}
                    >
                      <div className="box text-center">{t('breadcrumb.ageYears', { age: parseInt(key, 10) })}</div>
                    </Link>
                  ))}
                </Collapsible>
              </div>
            ) : null} */}

            {/* {showPreschoolerDropdown ? (
              <div className="col col-md-12">
                <div className="d-flex align-items-center mb-3 mb-md-4 gap-2">
                  <div className="icon-bg" weight="30" height="30">
                    <img src="/assets/images/icons/preschooler.svg" alt="icon" />
                  </div>
                  <h3 className="font-thin h3 heading-text">Preschooler</h3>
                </div>
                <Collapsible title={'3-4 years old'} id={3} className="age-accordion" grid>
                  {Object.keys(preSchoolerMap).map((key) => (
                    <Link
                      key={key}
                      prefetch={false}
                      href={preSchoolerMap[key]}
                      className={enablePrimaryLink(key, preSchoolerMap[key]) ? 'primary-age' : 'secondary-age'}
                    >
                      <div className="box text-center">{t('breadcrumb.ageYears', { age: parseInt(key, 10) })}</div>
                    </Link>
                  ))}
                </Collapsible>
              </div>
            ) : null} */}

            {/* {showChildDropdown ? (
              <div className="col col-md-12">
                <div className="d-flex align-items-center mb-3 mb-md-4 gap-2">
                  <div className="icon-bg" weight="30" height="30">
                    <img src="/assets/images/icons/child.svg" alt="icon" />
                  </div>
                  <h3 className="font-thin h3 heading-text">Child</h3>
                </div>
                <Collapsible title={'5-12 years old'} id={4} className="age-accordion" grid>
                  {Object.keys(childMap).map((key) => (
                    <Link
                      key={key}
                      prefetch={false}
                      href={childMap[key]}
                      className={enablePrimaryLink(key, childMap[key]) ? 'primary-age' : 'secondary-age'}
                    >
                      <div className="box text-center">{t('breadcrumb.ageYears', { age: parseInt(key, 10) })}</div>
                    </Link>
                  ))}
                </Collapsible>
              </div>
            ) : null} */}

            {showTeenagerDropdown ? (
              <div className="col col-md-12">
                <div className="d-flex align-items-center mb-3 mb-md-4 gap-2">
                  <div className="icon-bg" weight="30" height="30">
                    <img src="/assets/images/icons/teenager.svg" alt="icon" />
                  </div>
                  <h3 className="font-thin h3 heading-text">{t('ageGroup.teenagers')}</h3>
                </div>
                <Collapsible title={t('ageGroup.range', { lo: 15, hi: 19 })} key={5} className="age-accordion" grid>
                  {Object.keys(teenMap).map((key) => (
                    <Link
                      key={key}
                      prefetch={false}
                      href={teenMap[key]}
                      className={enablePrimaryLink(key, teenMap[key]) ? 'primary-age' : 'secondary-age'}
                    >
                      <div className="box text-center">{t('breadcrumb.ageYears', { age: parseInt(key, 10) })}</div>
                    </Link>
                  ))}
                </Collapsible>
              </div>
            ) : null}
            {showTeenagerDropdown ? (
              <div className="col col-md-12">
                <div className="d-flex align-items-center mb-3 mb-md-4 gap-2">
                  <div className="icon-bg" weight="30" height="30">
                    <img src="/assets/images/icons/teenager.svg" alt="icon" />
                  </div>
                  <h3 className="font-thin h3 heading-text">{t('ageGroup.youngAdults')}</h3>
                </div>
                <Collapsible title={t('ageGroup.range', { lo: 20, hi: 24 })} key={5} className="age-accordion" grid>
                  {Object.keys(youngAdult).map((key) => (
                    <Link
                      key={key}
                      prefetch={false}
                      href={youngAdult[key]}
                      className={enablePrimaryLink(key, youngAdult[key]) ? 'primary-age' : 'secondary-age'}
                    >
                      <div className="box text-center">{t('breadcrumb.ageYears', { age: parseInt(key, 10) })}</div>
                    </Link>
                  ))}
                </Collapsible>
              </div>
            ) : null}
            {showTeenagerDropdown ? (
              <div className="col col-md-12">
                <div className="d-flex align-items-center mb-3 mb-md-4 gap-2">
                  <div className="icon-bg" weight="30" height="30">
                    <img src="/assets/images/icons/teenager.svg" alt="icon" />
                  </div>
                  <h3 className="font-thin h3 heading-text">{t('ageGroup.youngProfessionals')}</h3>
                </div>
                <Collapsible title={t('ageGroup.range', { lo: 25, hi: 34 })} key={5} className="age-accordion" grid>
                  {Object.keys(youngProfessional).map((key) => (
                    <Link
                      key={key}
                      prefetch={false}
                      href={youngProfessional[key]}
                      className={enablePrimaryLink(key, youngProfessional[key]) ? 'primary-age' : 'secondary-age'}
                    >
                      <div className="box text-center">{t('breadcrumb.ageYears', { age: parseInt(key, 10) })}</div>
                    </Link>
                  ))}
                </Collapsible>
              </div>
            ) : null}
            {showTeenagerDropdown ? (
              <div className="col col-md-12">
                <div className="d-flex align-items-center mb-3 mb-md-4 gap-2">
                  <div className="icon-bg" weight="30" height="30">
                    <img src="/assets/images/icons/teenager.svg" alt="icon" />
                  </div>
                  <h3 className="font-thin h3 heading-text">{t('ageGroup.professionalAdults')}</h3>
                </div>
                <Collapsible title={t('ageGroup.range', { lo: 35, hi: 44 })} key={5} className="age-accordion" grid>
                  {Object.keys(professionalAdult).map((key) => (
                    <Link
                      key={key}
                      prefetch={false}
                      href={professionalAdult[key]}
                      className={enablePrimaryLink(key, professionalAdult[key]) ? 'primary-age' : 'secondary-age'}
                    >
                      <div className="box text-center">{t('breadcrumb.ageYears', { age: parseInt(key, 10) })}</div>
                    </Link>
                  ))}
                </Collapsible>
              </div>
            ) : null}
            {showTeenagerDropdown ? (
              <div className="col col-md-12">
                <div className="d-flex align-items-center mb-3 mb-md-4 gap-2">
                  <div className="icon-bg" weight="30" height="30">
                    <img src="/assets/images/icons/teenager.svg" alt="icon" />
                  </div>
                  <h3 className="font-thin h3 heading-text">{t('ageGroup.middleAgedAdults')}</h3>
                </div>
                <Collapsible title={t('ageGroup.range', { lo: 45, hi: 54 })} key={5} className="age-accordion" grid>
                  {Object.keys(middleAgedAdult).map((key) => (
                    <Link
                      key={key}
                      prefetch={false}
                      href={middleAgedAdult[key]}
                      className={enablePrimaryLink(key, middleAgedAdult[key]) ? 'primary-age' : 'secondary-age'}
                    >
                      <div className="box text-center">{t('breadcrumb.ageYears', { age: parseInt(key, 10) })}</div>
                    </Link>
                  ))}
                </Collapsible>
              </div>
            ) : null}
            {showTeenagerDropdown ? (
              <div className="col col-md-12">
                <div className="d-flex align-items-center mb-3 mb-md-4 gap-2">
                  <div className="icon-bg" weight="30" height="30">
                    <img src="/assets/images/icons/teenager.svg" alt="icon" />
                  </div>
                  <h3 className="font-thin h3 heading-text">{t('ageGroup.lateMiddleAgedAdults')}</h3>
                </div>
                <Collapsible title={t('ageGroup.range', { lo: 55, hi: 64 })} key={5} className="age-accordion" grid>
                  {Object.keys(lateMiddleAgedAdult).map((key) => (
                    <Link
                      key={key}
                      prefetch={false}
                      href={lateMiddleAgedAdult[key]}
                      className={enablePrimaryLink(key, lateMiddleAgedAdult[key]) ? 'primary-age' : 'secondary-age'}
                    >
                      <div className="box text-center">{t('breadcrumb.ageYears', { age: parseInt(key, 10) })}</div>
                    </Link>
                  ))}
                </Collapsible>
              </div>
            ) : null}
            {showTeenagerDropdown ? (
              <div className="col col-md-12">
                <div className="d-flex align-items-center mb-3 mb-md-4 gap-2">
                  <div className="icon-bg" weight="30" height="30">
                    <img src="/assets/images/icons/teenager.svg" alt="icon" />
                  </div>
                  <h3 className="font-thin h3 heading-text">{t('ageGroup.retirees')}</h3>
                </div>
                <Collapsible title={t('ageGroup.range', { lo: 65, hi: 74 })} key={5} className="age-accordion" grid>
                  {Object.keys(retirees).map((key) => (
                    <Link
                      key={key}
                      prefetch={false}
                      href={retirees[key]}
                      className={enablePrimaryLink(key, retirees[key]) ? 'primary-age' : 'secondary-age'}
                    >
                      <div className="box text-center">{t('breadcrumb.ageYears', { age: parseInt(key, 10) })}</div>
                    </Link>
                  ))}
                </Collapsible>
              </div>
            ) : null}
            {showTeenagerDropdown ? (
              <div className="col col-md-12">
                <div className="d-flex align-items-center mb-3 mb-md-4 gap-2">
                  <div className="icon-bg" weight="30" height="30">
                    <img src="/assets/images/icons/teenager.svg" alt="icon" />
                  </div>
                  <h3 className="font-thin h3 heading-text">{t('ageGroup.seniors')}</h3>
                </div>
                <Collapsible title={t('ageGroup.range', { lo: 75, hi: 100 })} key={5} className="age-accordion" grid>
                  {Object.keys(seniors).map((key) => (
                    <Link
                      key={key}
                      prefetch={false}
                      href={seniors[key]}
                      className={enablePrimaryLink(key, seniors[key]) ? 'primary-age' : 'secondary-age'}
                    >
                      <div className="box text-center">{t('breadcrumb.ageYears', { age: parseInt(key, 10) })}</div>
                    </Link>
                  ))}
                </Collapsible>
              </div>
            ) : null}
          </div>
        </div>
        <div className="wrapper-md pt-3">
          <div className="row">
            {contentBlock && contentBlock.content && (
              <div className="col-12" dangerouslySetInnerHTML={{ __html: contentBlock.content }}></div>
            )}
          </div>
        </div>
      </div>
      <script
        type="application/ld+json"
        id="schema-script"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: `${formulateGenderAndChartType(hashArray, locale)} Charts`,
            description: hashArray[1].includes('net-worth')
              ? `Compare net worth charts for ${hashArray[2]} of all ages. See averages, track financial progress, and benchmark your position nationally`
              : hashArray[1].includes('head')
              ? `View head circumference charts specifically for ${hashArray[2]} to track growth patterns.`
              : hashArray[1].includes('height')
              ? `View detailed height charts specifically for ${hashArray[2]} to track growth patterns.`
              : `Access weight charts designed for ${hashArray[2]}, helping track growth and health trends.`,
            publisher: {
              '@type': 'Organization',
              name: 'NettleWorth',
              logo: {
                '@type': 'ImageObject',
                url: `${process.env.NEXT_PUBLIC_BASE_URL}/assets/images/logos/LM-logo.svg`,
              },
            },
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': `${process.env.NEXT_PUBLIC_BASE_URL}/${hashArray[1]}/${hashArray[2]}`,
            },
          }),
        }}
      />
    </div>
  );
};

export default ChartsGender;
